export const INITIATIVE = {
    FSBO: 'wl_fsbo',
    FRBO: 'wl_frbo',
    FSRBO: 'wl_fsrbo',
};
